<template>
  <div class="home-page">
    <THeader/>
    <home-description />
    <div class="container">
      <div class="content">
        <div class="content-block">
          <h3>Отправить груз из Мелитополя</h3>
          <span class="content-title-red">в любую точку России!</span>
          <div class="content-title-line" />
        </div>
        <div class="content-block">
          <div class="content-title-gray">Мы Вас ждем!</div>
          <div style="max-width: 360px">
            <span>С 9 декабря в Мелитополе можно отправить и получить посылки в любую точку России.</span>
          </div>
        </div>
        <div class="content-block news">
          <h2>Новости</h2>
          <news-item v-for="(newsItem, i) in news" :key="i" :value="newsItem" />
        </div>
      </div>
      <div class="calculator">
        <h2>Рассчитать стоимость</h2>
        <iframe
          :src="iframeSrc"
          frameborder="0"
        />
      </div>
    </div>
  </div>
</template>

<script>
import THeader from '@/components/THeader'
import news from '@/news/index.ts'
import NewsItem from '@/components/NewsItem'
import HomeDescription from '@/components/HomeDescription'

export default {
  name: 'HomePage',
  components: {HomeDescription, NewsItem, THeader},

  setup() {
    const iframeSrc = 'https://calc.apex-tech.ru/iframe/calculator/?color=%23e42c31&dispatch_point=ebcb9168-70a1-11ed-ae68-ac1f6b447939&destination_point=e90f1820-0128-11e5-80c7-00155d903d03&volume=0.1&weight=0.1&link=1'

    return {
      news,
      iframeSrc
    }
  }
}
</script>

<style scoped>
.container {
  width: 1280px;
  max-width: 95%;
  margin: 0 auto;
  padding: 60px 0 80px;
  display: flex;
  align-items: flex-start;
  gap: 60px;
}
.content {
  text-align: left;
}
.content .content-block:not(:last-child) {
  margin-bottom: 40px;
}
.content .news {
  background-color: var(--bg-2);
  border-radius: 12px;
  padding: 20px 30px;
  margin-top: 50px;
}
.content .content-title-gray {
  color: var(--font-1);
  font-size: 22px;
  font-weight: 600;
  margin-bottom: 10px;
}
.content h3 {
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 6px;
  color: var(--font-1);
}
.content h2 {
  font-size: 22px;
  font-weight: 700;
  margin: 0 0 24px;
  color: var(--primary-color);
}
.content .content-title-red {
  color: var(--primary-color);
  text-transform: uppercase;
  font-size: 30px;
  font-weight: 700;
  margin-top: 0;
}
.content p {
  font-size: 18px;
  line-height: 36px;
}
.content-title-line {
  width: 40px;
  height: 5px;
  background-color: var(--primary-color);
  margin-top: 25px;
}
.calculator {
  /*padding: 10px;*/
  width: 100%;
  min-width: 300px;
  max-width: 448px;
  border: 1px solid var(--line);
  box-shadow: var(--box-shadow);
}
.calculator iframe {
  height: 455px;
  width: 100%;
  margin: 0;
  line-height: 1;
  border: none;
}
.calculator h2 {
  text-transform: uppercase;
  margin-bottom: 0;
  color: var(--font-1);
}

@media screen and (min-width: 769px) and (max-width: 940px) {
  .calculator iframe {
    height: 630px;
  }
}
@media screen and (max-width: 768px) {
  .container {
    flex-direction: column-reverse;
    align-items: center;
    gap: 70px;
    padding: 40px 0;
  }
  .content h3, .content .content-title-red {
    font-size: 32px;
  }
  .content .content-block {
    margin-bottom: 32px;
  }
  .calculator {
    max-width: min(95%, 448px);
  }
}
</style>
